const hideShowContainers = document.querySelectorAll(".hide-show-content");

function toggleHeightControl(clickedAccordion) {
  const clickedAccordionContent = clickedAccordion.querySelector(
    ".custom-accordion__content"
  );
  const isExpanded =
    clickedAccordionContent.getAttribute("aria-hidden") === "true";
  if (isExpanded) {
    clickedAccordionContent.setAttribute("aria-hidden", "false");
    clickedAccordion.setAttribute("aria-expanded", "false");
  } else {
    clickedAccordion.setAttribute("aria-expanded", "true");
    clickedAccordionContent.setAttribute("aria-hidden", "true");
  }
}

hideShowContainers.forEach((hideShowContainer) => {
  hideShowContainer.addEventListener("click", (e) => {
    if (
      e.target.closest(".custom-accordion") &&
      !e.target.closest(".custom-accordion__content")
    ) {
      toggleHeightControl(e.target.closest(".custom-accordion"));
    } else {
      return;
    }
  });
});
